import { createSelector, MemoizedSelector } from '@ngrx/store';

import * as fromAccountInformation from '../reducers/account-information.reducer';
import * as fromFeature from './../reducers';
import { Account } from '../../model/account';

export const getAccountInformationSlice: MemoizedSelector<
  object,
  any
> = createSelector(
  fromFeature.getAccountState,
  (state: fromFeature.AccountState) => state.accountInformation
);

export const getAccountInformation: MemoizedSelector<
  object,
  Account
> = createSelector(
  getAccountInformationSlice,
  fromAccountInformation.getAccountInformationEntity
);

export const getAccountInformationLoaded: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getAccountInformationSlice,
  fromAccountInformation.getAccountInformationLoaded
);

export const getAccountInformationLoading: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getAccountInformationSlice,
  fromAccountInformation.getAccountInformationLoading
);

export const getHasManagerAccess: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getAccountInformationSlice,
  fromAccountInformation.getHasManagerAccess
);
